import PropTypes from 'prop-types';
import { Tooltip } from '@codex/basics';
import styled from 'styled-components';

const StyledTooltip = styled(Tooltip)`
  display: inline-block;
  color: #ed8812;
  font-size: 13px;
  padding: 10px;
  border: 0;
  margin-bottom: 0;
  margin-right: 5px;
  border-radius: 3px;
`;

const DivWrapper = styled.div` 
  display: flex;
  align-items: center;

  span > div[data-component='Tooltip'] {
    color: #c90404;
    background: #ffefef;
    border: 1px solid #c90404;
  }
`;

const DivCounts = styled.div` 
  margin-right: 5px;
`;

function ProductListingResultsMessage(props) {
  return (
    <DivWrapper className={'dc-product-listing__results-message'}>
      <DivCounts className={'dc-product-listing__products-count'}>
        <strong>
          <span>{props.noResults ? 'No results found' : props.showingResultsLabel}</span>
          {' '}
          {/* TODO: Add to translations */}
        </strong>
      </DivCounts>
      {props.productsRequestErrorMessage &&
        (props.deviceType === 'wide' || props.deviceType === 'desktop') && (
        <StyledTooltip type={'warning'}>
          {'Sorry, we can\'t apply filters just now. Please try later.'}
          {' '}
          {/* TODO: Add to translations */}
        </StyledTooltip>
      )}
      {props.categoryProductCount === 0 &&
        (props.deviceType === 'wide' || props.deviceType === 'desktop') && (
        <StyledTooltip type={'warning'}>
          Please remove some of your filters
          {' '}
          {/* TODO: Add to translations */}
        </StyledTooltip>
      )}
    </DivWrapper>
  );
}

ProductListingResultsMessage.displayName = 'ProductListingResultsMessage';

ProductListingResultsMessage.propTypes = {
  showingResultsLabel: PropTypes.string.isRequired,
  productsRequestErrorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  deviceType: PropTypes.oneOf(['wide', 'desktop', 'tablet', 'mobile']),
  categoryProductCount: PropTypes.number.isRequired,
  noResults: PropTypes.bool.isRequired
};

ProductListingResultsMessage.defaultProps = {
  productsRequestErrorMessage: null,
  deviceType: 'wide'
};

export default ProductListingResultsMessage;
